import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { Suspense, ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Button } from '@mantine/core'
import { TbReload } from 'react-icons/tb'
import ErrorState from './ErrorState'
import PageShell from './PageShell'
import { useTranslation } from 'react-i18next'

export function QueryBoundary({
  children,
  loadingFallback,
  errorTitle,
  errorMessage,
  pageTitle,
  fullWidth = false,
  backButtonHref,
}: {
  children: ReactNode
  loadingFallback: ReactNode
  errorTitle: string
  errorMessage?: string
  pageTitle?: string
  fullWidth?: boolean
  backButtonHref?: string
}) {
  const { t } = useTranslation('common')

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ error, resetErrorBoundary }) => (
            <PageShell title={pageTitle || errorTitle} fullWidth={fullWidth}>
              <ErrorState
                title={errorTitle}
                message={error.message || errorMessage || t('anErrorOccurred')}
                customAction={
                  <Button
                    mt="md"
                    leftSection={<TbReload size={16} />}
                    variant="light"
                    onClick={resetErrorBoundary}
                    size="sm"
                    color="red"
                  >
                    {t('retry')}
                  </Button>
                }
                backButtonHref={backButtonHref}
              />
            </PageShell>
          )}
        >
          <Suspense fallback={loadingFallback}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
